export default __webpack_public_path__ + "static/media/soyl_holiday_social_1.54708cc0.jpg";